angular.module("vgresiduos").controller("AreaListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "organizacao/areas");
		};
	}
]);
